import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/credit-card-icon/visa.svg'
import _imports_1 from '@/assets/images/credit-card-icon/mastercard.svg'
import _imports_2 from '@/assets/images/credit-card-icon/diners_club.svg'
import _imports_3 from '@/assets/images/credit-card-icon/jcb.svg'
import _imports_4 from '@/assets/images/credit-card-icon/amex.svg'


const _withScopeId = n => (_pushScopeId("data-v-9b363f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }, " お支払い方法 ", -1))
const _hoisted_2 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_3 = {
  key: 0,
  class: "payment-panel"
}
const _hoisted_4 = { class: "ncgr-pad-t-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "pencil"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_8 = { class: "ncgr-interactive-list" }
const _hoisted_9 = { class: "_item" }
const _hoisted_10 = { for: "payment-method-credit-card" }
const _hoisted_11 = { class: "_leading" }
const _hoisted_12 = { class: "_input" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " クレジットカード・デビットカード ")
], -1))
const _hoisted_15 = { class: "_content" }
const _hoisted_16 = { class: "ncgr-pad-l-48" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"ncgr-credit-card-icon ncgr-mar-t-16 ncgr-mar-b-16\" data-v-9b363f10><div class=\"ncgr-credit-card-icon__item\" data-v-9b363f10><img src=\"" + _imports_0 + "\" class=\"ncgr-credit-card-icon__image\" alt=\"VISA\" data-v-9b363f10></div><div class=\"ncgr-credit-card-icon__item\" data-v-9b363f10><img src=\"" + _imports_1 + "\" class=\"ncgr-credit-card-icon__image\" alt=\"Mastercard\" data-v-9b363f10></div><div class=\"ncgr-credit-card-icon__item\" data-v-9b363f10><img src=\"" + _imports_2 + "\" class=\"ncgr-credit-card-icon__image\" alt=\"Diners Club\" data-v-9b363f10></div><div class=\"ncgr-credit-card-icon__item\" data-v-9b363f10><img src=\"" + _imports_3 + "\" class=\"ncgr-credit-card-icon__image\" alt=\"JCB\" data-v-9b363f10></div><div class=\"ncgr-credit-card-icon__item\" data-v-9b363f10><img src=\"" + _imports_4 + "\" class=\"ncgr-credit-card-icon__image\" alt=\"American Express\" data-v-9b363f10></div></div>", 1)
const _hoisted_18 = { class: "credit-card" }
const _hoisted_19 = { class: "ncgr-mar-b-16" }
const _hoisted_20 = { class: "ncgr-mar-b-16" }
const _hoisted_21 = { class: "ncgr-mar-b-16" }
const _hoisted_22 = { class: "ncgr-interactive-list" }
const _hoisted_23 = { class: "_item" }
const _hoisted_24 = { for: "credit-card-remember" }
const _hoisted_25 = { class: "_leading" }
const _hoisted_26 = { class: "_input" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " カード情報を保存する ")
], -1))
const _hoisted_29 = {
  key: 0,
  class: "payment-panel"
}
const _hoisted_30 = {
  class: "interactive-list",
  for: "payment-method-deferred"
}
const _hoisted_31 = ["checked"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " コンビニ・銀行 ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ncgr-pad-l-48" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ncgr-typography-small ncgr-typography-secondary-label ncgr-pad-l-4" }, " 手数料 330円 ")
], -1))
const _hoisted_34 = {
  key: 2,
  class: "payment-panel"
}
const _hoisted_35 = {
  class: "interactive-list",
  for: "payment-method-sample"
}
const _hoisted_36 = ["checked"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " サンプル発注 ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ncgr-pad-l-48" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ncgr-typography-small ncgr-typography-secondary-label ncgr-pad-l-4" }, " サンプル発注は、担当者にその旨を連絡した上で行うようお願いします。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormattableField = _resolveComponent("FormattableField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showRegisteredCard && _ctx.registeredCreditCard && !_ctx.isSample)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, "前回ご利用のカード（有効期限：" + _toDisplayString(_ctx.registeredCreditCard.expireYear) + "/" + _toDisplayString(_ctx.registeredCreditCard.expireMonth) + "）", 1),
            _createElementVNode("button", {
              class: "ncgr-button -appearance-flat credit-card-edit-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleEditRegisteredCard && _ctx.handleEditRegisteredCard(...args)))
            }, _hoisted_6)
          ]))
        : (!_ctx.isSample)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "ncgr-radio",
                            name: "payment-method-type",
                            id: "payment-method-credit-card",
                            value: "creditCard",
                            checked: _ctx.isCreditCardSelected,
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitInput($event, 'method')))
                          }, null, 40, _hoisted_13)
                        ])
                      ]),
                      _hoisted_14
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_FormattableField, {
                              label: "カード番号",
                              type: "tel",
                              name: "credit-card-number",
                              id: "credit-card-number",
                              placeholder: "4100-1234-1234-1234",
                              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitInput($event, 'cardNumber'))),
                              initValue: _ctx.payment.cardNumber,
                              validator: _ctx.validateCardNumber,
                              format: _ctx.formatCardNumber
                            }, null, 8, ["initValue", "validator", "format"])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_FormattableField, {
                              label: "有効期限",
                              type: "tel",
                              name: "credit-card-expire",
                              id: "credit-card-expire",
                              placeholder: "05/23",
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitInput($event, 'cardExpiration'))),
                              initValue: _ctx.payment.cardExpiration,
                              validator: _ctx.validateCardExpiration,
                              format: _ctx.formatCardExpiration
                            }, null, 8, ["initValue", "validator", "format"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_FormattableField, {
                              label: "セキュリティコード",
                              type: "tel",
                              name: "credit-card-security-code",
                              id: "credit-card-security-code",
                              placeholder: "123",
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitInput($event, 'cardSecurityCode'))),
                              initValue: _ctx.payment.cardSecurityCode,
                              validator: _ctx.validateCardSecurityCode,
                              format: _ctx.formatCardSecurityCode
                            }, null, 8, ["initValue", "validator", "format"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "ncgr-checkbox",
                                    name: "credit_card_remember",
                                    id: "credit-card-remember",
                                    checked: _ctx.payment.cardRemember,
                                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitCheckboxInput($event, 'cardRemember')))
                                  }, null, 40, _hoisted_27)
                                ])
                              ]),
                              _hoisted_28
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                      _createElementVNode("input", {
                        class: "ncgr-radio",
                        type: "radio",
                        name: "payment-method-type",
                        id: "payment-method-deferred",
                        value: "deferred",
                        checked: _ctx.isDeferredSelected,
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitInput($event.target.value, 'method')))
                      }, null, 40, _hoisted_31),
                      _hoisted_32
                    ]),
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, [
                _createElementVNode("input", {
                  class: "ncgr-radio",
                  type: "radio",
                  name: "payment-method-type",
                  id: "payment-method-sample",
                  value: "sampleOrder",
                  checked: _ctx.isSampleSelected,
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitInput($event.target.value, 'method')))
                }, null, 40, _hoisted_36),
                _hoisted_37
              ]),
              _hoisted_38
            ]))
    ])
  ]))
}